module.exports = __webpack_public_path__ + "static/media/bateria.ce0f24e9.svg";